import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ChevronLeft16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M9.48333 3.2539L9.48228 3.25493L5.27036 7.42932C5.08109 7.58853 5 7.79721 5 7.99964C5 8.20217 5.08048 8.40714 5.24092 8.56526L9.48263 12.7447C9.81767 13.0719 10.3714 13.0867 10.7223 12.7769C11.0785 12.4638 11.0892 11.9406 10.7555 11.6133L7.08839 7.99969L10.7583 4.38611C11.0924 4.05813 11.0792 3.5367 10.7244 3.22269C10.3721 2.91444 9.81861 2.92746 9.48333 3.2539Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
